<template>
	<Row class="page-container-row">
		<Col
			class="width-limit-page-col"
			:span="24"
			:offset="0"
			:lg="{ span: 18, offset: 3 }"
			:xl="{ span: 12, offset: 6 }"
		>
			<PageContainer :withCloseButton="true">
				<LoginForm />
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { Row, Col } from 'ant-design-vue';

import LoginForm from '@/components/login/LoginForm';
import PageContainer from '@/components/common/PageContainer';

export default {
	components: {
		Row, Col, LoginForm, PageContainer,
	},
}
</script>
